<script setup lang="ts">
// Footer component matching the Blade design
</script>

<template>
  <footer class="main-footer">
    <div class="footerCopyRightNavRow mt-5">
      <div class="container">
        <div class="row">
          <!-- Bangladesh Office -->
          <div class="col-lg-8 col-md-6 mb-3 office-info">
            <strong>Bangladesh Office:</strong>
            <p>2nd floor, Ka-24/4, Sarkar Market (Opposite of Syed Ali Super Market),<br>
              Bashundhara R/A Main Gate, Dhaka-1229</p>

            <strong>China Office:</strong>
            <p>Travel Beijing TripTricks Travel Co. Ltd<br>
              Address: Bldg 2, No.66 Yanfu Rd, Fangshan, Beijing - 102400</p>

            <strong>Liaison Office:</strong>
            <p>India, Thailand, Nepal</p>
          </div>

          <!-- Support Section -->
          <div class="col-lg-4 col-md-6 d-flex mb-3 support-section">
            <div>
              <p><strong>For Support:</strong></p>
              <hr>
              <p>+8801716436241, +8801951144402, +8801951144410</p>
              <p>info@b2btourdeal.com</p>
              <ul class="list-unstyled">
                <li>
                  <a class="whatsapp-link" href="https://chat.whatsapp.com/J0Qcxot6defA2Vf145eh4K" target="_blank">
                    <i class="fab fa-whatsapp"></i> Join Whatsapp Group
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <hr>
        <p class="concern-text">A Concern Of Trip Tricks</p>
      </div>
    </div>
  </footer>
</template>

<style scoped>
@import url("./AppFooter.css");
</style>

